var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var AnalyticsValues;
(function (AnalyticsValues) {
    AnalyticsValues["cbr"] = "cbr";
    AnalyticsValues["manageCreditBalance"] = "Manage credit balance";
    AnalyticsValues["error"] = "error";
    AnalyticsValues["errorMessage"] = "we're having trouble retrieving your information";
    AnalyticsValues["digitalServicing"] = "digital-servicing";
    AnalyticsValues["view"] = "view";
    AnalyticsValues["review"] = "review";
    AnalyticsValues["submitted"] = "submitted";
    AnalyticsValues["refundSubmitted"] = "refund request submitted";
    AnalyticsValues["refundInProgress"] = "refund in progress";
    AnalyticsValues["refundRequestInProgress"] = "refund request in progress";
})(AnalyticsValues || (AnalyticsValues = {}));
export var TriggerAnalyticsKeys;
(function (TriggerAnalyticsKeys) {
    TriggerAnalyticsKeys["pageKind"] = "pageKind";
    TriggerAnalyticsKeys["pageName"] = "pageName";
    TriggerAnalyticsKeys["pageFunction"] = "pageFunction";
    TriggerAnalyticsKeys["pageSubFunction"] = "pageSubFunction";
    TriggerAnalyticsKeys["token"] = "token";
    TriggerAnalyticsKeys["message"] = "message";
    TriggerAnalyticsKeys["errorMessage"] = "errorMessage";
})(TriggerAnalyticsKeys || (TriggerAnalyticsKeys = {}));
export var analyticsValues = {
    cbr: 'cbr',
    manageCreditBalance: 'Manage credit balance',
    error: 'error',
    errorMessage: 'Sorry, something went wrong.',
    digitalServicing: 'digital-servicing',
    view: 'view',
    review: 'review',
    submitted: 'submitted',
    refundSubmitted: 'refund request submitted',
    refundInProgress: 'refund request in progress',
    authenticate: 'authenticate login'
};
export var dataObjects = {
    link: 'link',
    button: 'button'
};
export var dataTypes = {
    backToAccountManager: 'back to account manager',
    backToAccountManagement: 'back to account management',
    requestRefundCheck: 'request refund check',
    startChat: 'start chat',
    manageCreditBalance: 'manage credit balance',
    submit: 'submit',
    back: 'back',
    cbr: 'cbr',
    onlineChat: 'online chat'
};
export var dataReasons = {
    saveCredit: 'Save your credit for your future purchase',
    requestRefundCheck: 'request refund check',
    manageCreditBalance: 'manage credit balance',
    backToAccountManager: 'back to account manager',
    submit: 'submit',
    back: 'back',
    manageProfile: 'manage profile'
};
export var backToAccountManagerDataProps = {
    'data-object': dataObjects.button,
    'data-type': dataTypes.backToAccountManager,
    'data-reason': dataReasons.saveCredit,
    'data-analytics': 'clicktrackingevent'
};
export var manageProfileLinkDataProps = {
    'data-object': dataObjects.link,
    'data-type': dataTypes.cbr,
    'data-reason': dataReasons.manageProfile,
    'data-analytics': 'clicktrackingevent'
};
export var backToAccountManagerSubmittedDataProps = __assign(__assign({}, backToAccountManagerDataProps), { 'data-reason': dataReasons.backToAccountManager });
export var backToAccountManagerWithError = __assign(__assign({}, backToAccountManagerDataProps), { 'data-reason': analyticsValues.errorMessage });
export var requestRefundDataProps = __assign(__assign({}, backToAccountManagerDataProps), { 'data-type': dataTypes.requestRefundCheck, 'data-reason': dataReasons.requestRefundCheck });
export var startChatDataProps = __assign(__assign({}, backToAccountManagerDataProps), { 'data-object': dataObjects.link, 'data-type': dataTypes.startChat, 'data-reason': dataReasons.requestRefundCheck });
export var manageCreditBalanceDataProps = __assign(__assign({}, backToAccountManagerDataProps), { 'data-type': dataTypes.manageCreditBalance, 'data-reason': dataReasons.manageCreditBalance });
export var submitDataProps = __assign(__assign({}, backToAccountManagerDataProps), { 'data-type': dataTypes.submit, 'data-reason': dataReasons.submit });
export var backDataProps = __assign(__assign({}, backToAccountManagerDataProps), { 'data-type': dataTypes.back, 'data-reason': dataReasons.back });
export var triggerAnalyticsKeys = {
    pageKind: TriggerAnalyticsKeys.pageKind,
    pageName: TriggerAnalyticsKeys.pageName,
    pageFunction: TriggerAnalyticsKeys.pageFunction,
    pageSubFunction: TriggerAnalyticsKeys.pageSubFunction,
    token: TriggerAnalyticsKeys.token,
    message: TriggerAnalyticsKeys.message,
    errorMessage: TriggerAnalyticsKeys.errorMessage
};
// CBR Drawer analytic props
export var backToAccountManagementDataProps = __assign(__assign({}, backToAccountManagerDataProps), { 'data-type': dataTypes.backToAccountManagement });
export var xButtonDataProps = __assign(__assign({}, backToAccountManagerDataProps), { 'data-object': 'button', 'data-reason': 'cbr', 'data-type': 'x button' });
export var footerCloseButtonDataProps = __assign(__assign({}, xButtonDataProps), { 'data-type': 'close' });
export var onlineChatLinkDataProps = __assign(__assign({}, backToAccountManagerDataProps), { 'data-type': dataTypes.onlineChat, 'data-reason': dataReasons.requestRefundCheck, 'data-object': dataObjects.link });
export var backToAccountManagementFooterDataProps = __assign(__assign({}, backToAccountManagerDataProps), { 'data-type': dataTypes.backToAccountManager, 'data-reason': dataTypes.backToAccountManager });
